export default {
  sidebarOptions: [
    { id: 'companies', labelStringId: 'companies', path: '/companies', iconName: 'CorporateFareOutlined' },
    { id: 'templates', labelStringId: 'templates', path: '/templates', iconName: 'DescriptionOutlined' },
  ],
};
